var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _vm.checkPermi(["merchant:product:page:list"])
        ? _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-position": "right",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "菜品名称：" } },
                        [
                          _c("el-input", {
                            staticClass: "form_content_width",
                            attrs: {
                              placeholder: "请输入菜品名称",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSeachList($event)
                              },
                            },
                            model: {
                              value: _vm.tableFrom.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tableFrom,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFrom.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleSeachList },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _vm.checkPermi(["merchant:product:page:list"])
            ? _c(
                "div",
                { ref: "headerBox", staticClass: "clearfix" },
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "list-tabs mb5",
                      on: { "tab-click": _vm.handleSeachList },
                      model: {
                        value: _vm.tableFrom.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "type", $$v)
                        },
                        expression: "tableFrom.type",
                      },
                    },
                    _vm._l(_vm.headeNum, function (item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: { label: item.name + "(" + item.count + ")" },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["merchant:product:save"],
                  expression: "['merchant:product:save']",
                },
              ],
              staticClass: "mt14 mr14",
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleAdd()
                },
              },
            },
            [_vm._v("添加菜品")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": true,
                "highlight-current-row": "",
              },
              on: {
                "selection-change": _vm.handleSelectionChange,
                "select-all": _vm.selectAll,
                select: _vm.selectOne,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm.checkedCities.includes("ID")
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", "min-width": "50" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("菜品图")
                ? _c("el-table-column", {
                    attrs: { label: "菜品图", "min-width": "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "demo-image__preview line-heightOne",
                                },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: scope.row.image,
                                      "preview-src-list": [scope.row.image],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1508102206
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("菜品名称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "菜品名称",
                      "min-width": "200",
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "tags_name",
                                    class: "name" + scope.row.specType,
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.specType
                                          ? "[多规格]"
                                          : "[单规格]"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(_vm._s(scope.row.name || "-") + " "),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      221850979
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("菜品售价")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "price",
                      label: "菜品售价",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("菜品售价")
                ? _c("el-table-column", {
                    attrs: { prop: "rank", label: "排序", "min-width": "90" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("状态")
                ? _c("el-table-column", {
                    attrs: { label: "状态", "min-width": "80", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.checkPermi([
                                "merchant:product:up",
                                "merchant:product:down",
                              ])
                                ? _c("el-switch", {
                                    attrs: {
                                      disabled:
                                        _vm.IsShow ||
                                        scope.row.auditStatus !== 2,
                                      "active-value": true,
                                      "inactive-value": false,
                                      "active-text": "上架",
                                      "inactive-text": "下架",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onchangeIsShow(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.isShow,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "isShow", $$v)
                                      },
                                      expression: "scope.row.isShow",
                                    },
                                  })
                                : _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.isShow ? "上架" : "下架")
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1906329349
                    ),
                  })
                : _vm._e(),
              _vm.tableFrom.type === "7"
                ? _c("el-table-column", {
                    attrs: {
                      label: "失败原因",
                      "min-width": "150",
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "textE93323" }, [
                                _vm._v(_vm._s(scope.row.reason)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3797934948
                    ),
                  })
                : _vm._e(),
              _c(
                "el-table-column",
                {
                  attrs: { width: "190", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.auditStatus === 4 ||
                          scope.row.auditStatus === 3
                            ? _c(
                                "a",
                                {
                                  staticClass: "mr10",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpdata(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("提交审核")]
                              )
                            : _vm._e(),
                          _c(
                            "a",
                            {
                              staticClass: "mr10",
                              on: {
                                click: function ($event) {
                                  return _vm.handleAdd(scope.row, 1)
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "mr10",
                              on: {
                                click: function ($event) {
                                  return _vm.handleAdd(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "mr10",
                              on: {
                                click: function ($event) {
                                  return _vm.handleEditList(scope.row)
                                },
                              },
                            },
                            [_vm._v("排序")]
                          ),
                          _c(
                            "a",
                            {
                              staticStyle: { color: "#ff0000" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("p", [
                      _c("span", { staticStyle: { "padding-right": "5px" } }, [
                        _vm._v("操作"),
                      ]),
                      _c("i", {
                        staticClass: "el-icon-setting",
                        on: { click: _vm.handleAddItem },
                      }),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.card_select_show,
                  expression: "card_select_show",
                },
              ],
              staticClass: "card_abs",
            },
            [
              [
                _c(
                  "div",
                  { staticClass: "cell_ht" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { indeterminate: _vm.isIndeterminate },
                        on: { change: _vm.handleCheckAllChange },
                        model: {
                          value: _vm.checkAll,
                          callback: function ($$v) {
                            _vm.checkAll = $$v
                          },
                          expression: "checkAll",
                        },
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.checkSave()
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-checkbox-group",
                  {
                    on: { change: _vm.handleCheckedCitiesChange },
                    model: {
                      value: _vm.checkedCities,
                      callback: function ($$v) {
                        _vm.checkedCities = $$v
                      },
                      expression: "checkedCities",
                    },
                  },
                  _vm._l(_vm.columnData, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item,
                        staticClass: "check_cell",
                        attrs: { label: item },
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  1
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "showHeader",
          attrs: {
            title: !_vm.stockEdit ? "免审编辑" : "编辑库存",
            visible: _vm.drawer,
            direction: _vm.direction,
            size: 1500,
            "before-close": _vm.handleCloseEdit,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.drawer && _vm.productId
            ? _c("store-edit", {
                attrs: {
                  productId: _vm.productId,
                  productType: _vm.productType,
                  stockEdit: _vm.stockEdit,
                  isSub: _vm.isSub,
                },
                on: { subSuccess: _vm.subSuccess },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-top",
          attrs: {
            visible: _vm.dialogVisible,
            title: "设置运费",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "75px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "运费模板：", prop: "tempId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "mr20",
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.formValidate.tempId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "tempId", $$v)
                        },
                        expression: "formValidate.tempId",
                      },
                    },
                    _vm._l(_vm.shippingTemplates, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "dialog-footer-inner" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btns",
                        attrs: { size: "small" },
                        on: { click: _vm.handleClose },
                      },
                      [_vm._v("取消")]
                    ),
                    _vm.checkPermi(["merchant:product:update"])
                      ? _c(
                          "el-button",
                          {
                            staticClass: "submission",
                            attrs: { type: "primary", loading: _vm.loadingBtn },
                            on: {
                              click: function ($event) {
                                return _vm.handleSubmit("formValidate")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.dialogCommision
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "设置佣金",
                visible: _vm.dialogCommision,
                width: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogCommision = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "commisionForm",
                  attrs: { model: _vm.commisionForm, rules: _vm.commisionRule },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "佣金模式：", prop: "commissionType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.commisionForm.commissionType,
                            callback: function ($$v) {
                              _vm.$set(_vm.commisionForm, "commissionType", $$v)
                            },
                            expression: "commisionForm.commissionType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("百分比"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("固定金额"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.commisionForm.commissionType === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "一级佣金比例：", prop: "brokerage" },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "priceBox",
                            attrs: {
                              step: 1,
                              "step-strictly": "",
                              min: 0,
                              max: 100,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.commisionForm.brokerage,
                              callback: function ($$v) {
                                _vm.$set(_vm.commisionForm, "brokerage", $$v)
                              },
                              expression: "commisionForm.brokerage",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.commisionForm.commissionType === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "二级佣金比例：",
                            prop: "brokerageTwo",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "priceBox",
                            attrs: {
                              step: 1,
                              min: 0,
                              "step-strictly": "",
                              max: 100,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.commisionForm.brokerageTwo,
                              callback: function ($$v) {
                                _vm.$set(_vm.commisionForm, "brokerageTwo", $$v)
                              },
                              expression: "commisionForm.brokerageTwo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.commisionForm.commissionType === 2
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "一级固定佣金：",
                            prop: "firstAmount",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "priceBox",
                            attrs: {
                              step: 0.01,
                              precision: 2,
                              min: 0,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.commisionForm.firstAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.commisionForm, "firstAmount", $$v)
                              },
                              expression: "commisionForm.firstAmount",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.commisionForm.commissionType === 2
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "二级固定佣金：",
                            prop: "secondAmount",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "priceBox",
                            attrs: {
                              step: 0.01,
                              precision: 2,
                              min: 0,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.commisionForm.secondAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.commisionForm, "secondAmount", $$v)
                              },
                              expression: "commisionForm.secondAmount",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("el-form-item", [
                    _vm.commisionForm.commissionType === 1
                      ? _c("span", [
                          _vm._v(
                            " 备注：订单交易成功后给推广员返佣的比例，例: 一级佣金比例设置 5，则返订单金额的 5% "
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            " 备注：固定金额模式会为该商品全部 SKU 设置统一的一级/二级固定佣金金额 "
                          ),
                        ]),
                  ]),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    { on: { click: _vm.handleCloseCommission } },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitCommisionForm("commisionForm")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isProducTpye
        ? _c("product-tpye", {
            ref: "productTpye",
            on: {
              success: function ($event) {
                return _vm.getList()
              },
              closeDialog: _vm.closeDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }